<template>
<div>

  <v-card>
    <v-card-title>
      {{titulo}}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fas fa-search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-container>
        <v-row>
          
          <v-col cols="12" sm="12" md="4">
            <v-autocomplete
              v-model="id_place"
              :items="places"
              item-text="name"
              item-value="id"
              label="Escoge la ubicación"
              clearable
              rounded
              solo
              hide-details
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-autocomplete
              v-model="id_coffee"
              :items="types"
              item-text="nombre"
              item-value="codigo"
              label="Escoge la clase de Café"
              clearable
              rounded
              solo
              hide-details
            ></v-autocomplete>
          </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value="dates"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateRangeText"
                label="Filtrar por fecha"
                prepend-icon="fa-calendar-alt"
                readonly
                filled
                rounded
                clearable
                hide-details
                :disabled="loading"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              range
              :title-date-format="title"
              scrollable
              :max="today"
            >
              <v-row no-gutters style="flex-wrap: nowrap;">
                <v-btn
                  class="flex-grow-1 flex-shrink-0"
                  large
                  rounded
                  outlined
                  color="primary"
                  @click="modal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  class="flex-grow-1 flex-shrink-0"
                  large
                  rounded
                  color="primary"
                  @click="
                    $refs.dialog.save(dates);
                    updateDateFilter();
                  "
                  >Aceptar</v-btn
                >
              </v-row>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="12" sm="12" md="2">
            <v-btn
              color="success"
              class="ma-2 white--text"
              @click="getByCustomer"
              block
            >
              Filtrar <v-icon right >
                fas fa-filter
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="warning"
              class="ma-2 white--text"
              @click="getAll"
              block
            >
              Ver Todo
              <v-icon right >
                fas fa-eye
              </v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12" sm="12" md="1">

            <v-tooltip top color="#0056b3">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  color="#007BFF"
                  @click="getSettings"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>
                    fas fa-cog
                  </v-icon>
                </v-btn>
              </template>
              <span>Precios de Movimientos</span>
            </v-tooltip>

          </v-col>

        </v-row>
    </v-container>

    <v-data-table
      :headers="headers"
      :items="currentItems"
      :search="search"
      sort-by="date"
      sort-desc
      class="elevation-1"
      :loading="loading"
      loading-text="Consultando datos... Espere por favor"
    >
    <template v-slot:[`item.date`]="{ item }">
        {{ dateFormat(item.date) }}
    </template>
    <template v-slot:[`item.costo`]="{ item }">
        {{ numberWithCommas(item.costo) }}
    </template>
    <template slot="body.append">
      <tr class="gray--text">
        <!-- <th class="title"></th> -->
        
        <th colspan="8" class="title">
        <v-row class="pt-2">
          <v-col offset="6" cols="12" sm="12" md="3" class="text-right">
            Cantidad: {{ numberWithCommas((parseFloat(sumField('total'))).toFixed(2)) }}
          </v-col>
          <v-col cols="12" sm="12" md="3" class="text-right">
            Costo: {{ numberWithCommas((parseFloat(sumField('costo'))).toFixed(2)) }}
          </v-col>
        </v-row>
        </th>
        
      </tr>
    </template>

    <template v-slot:top>
          <v-dialog 
          v-model="dialogFactor" 
          max-width="500px"
          >
            <v-card>
              
              <v-card-title>
                <span class="headline">Precios de Movimientos</span>
                <v-spacer></v-spacer>
                <div>

              <v-btn
                style="right:10px; top:10px;"
                icon
                color="error"
                fab
                absolute
                @click="dialogFactor = false"
              >
                <v-icon dark>fa-times</v-icon>
              </v-btn>

                </div>
              </v-card-title>

              <v-card-text>
                <v-container>

                  <v-data-table
                    :headers="headers_processes"
                    :items="types"
                    sort-by="nombre"
                    :loading="loading"
                    :hide-default-footer="true"
                    loading-text="Consultando datos... Espere por favor"
                  >
                  
                  <template v-slot:item.movement_price="props">
                    <v-edit-dialog
                      :return-value.sync="props.item.movement_price"
                      @save="saveFactor(props.item)"
                    >
                      {{ props.item.movement_price }}
                      <template v-slot:input>
                        <v-text-field
                          v-model="props.item.movement_price"
                          label="Editar"
                          single-line
                          type="number"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </template>

                  </v-data-table>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>
    </v-data-table>
  </v-card>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import * as moment from 'moment';

export default {
  name: "reportCrews",
  data: () => ({
    currentItems: [],
    samplings: [],
    categories: [],
    types: [],
    currentItems: [],
    items: [],
    item: {
        id: "",
        movement_price: "",
      },
    places: [],
    settings: {},
    id_category: null,
    dialogFactor: false,
    id_coffee: null,
    id_place: null,
    dates: [],
    loading: false,
    dialogDelete: false,
    loader: null,
    loading3: false,
    modal: false,
    search: "",
    loading: false,
    titulo: "Reporte de Movimientos de Cuadrilla",
    headers: [
      { text: "Fecha", align: "left", value: "date"},
      { text: "Lugar", align: "left", value: "place" },
      { text: "Nota", align: "left", value: "comment" },
      { text: "Clase de Café", align: "left", value: "coffee" },
      { text: "Cuadrilla", value: "crew" },
      { text: "Personal", value: "crew_daily" },
      { text: "Movientos", value: "movements" },
      { text: "Cantidad", value: "total" },
      { text: "Costo", value: "costo" },
    ],
    headers_processes: [
        { text: "Clase de Café", align: "left", value: "nombre" },
        { text: "Precio", value: "movement_price", sortable: false },
      ],
  }),

  computed: {
    
    ...mapState(["db","headers_db"]),
    dateRangeText: {
        get()
        {
            return this.dates.join(' ~ ')
        },
        set()
        {
            this.dates = []
        }
    },
    today() {
      return new Date().toISOString().substr(0, 10);
    },
  },

  watch: {
    // dialog(val) {
    //   val || this.close();
    // },
    loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 1000)

        this.loader = null
    },
  },

  methods: {
    ...mapActions(["validateSession"]),
    // Metodos base de datos
    async getSamplings(){
      await axios.get(this.db + 'report_crews',
        {
          headers: this.headers_db
        }).then(response => {
          this.samplings = this.currentItems = response.data.data;
          this.currentItems.forEach(element => {
            console.log('price', element.price);
            
            // if (element.price > 0) {
            //   element.costo = (((parseFloat(element.total) * parseFloat(element.price) * parseFloat(element.movements)) / (parseFloat(element.crew) + parseFloat(element.crew_daily)) * parseFloat(element.crew))).toFixed(2)
            // }
            // else {
            //   element.costo = (((parseFloat(element.total) * parseFloat(this.settings.movement_price) * parseFloat(element.movements)) / (parseFloat(element.crew) + parseFloat(element.crew_daily)) * parseFloat(element.crew))).toFixed(2)
            // }

            if (element.id_tipo_producto > 0) {
                  element.price = this.types.filter(doc => { return doc.codigo == element.id_tipo_producto; })[0].movement_price;
            }

            element.costo = (((parseFloat(element.total) * parseFloat(element.price) * parseFloat(element.movements)) / (parseFloat(element.crew) + parseFloat(element.crew_daily)) * parseFloat(element.crew))).toFixed(2)
          });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.validateSession(error).then((resp) => { if(resp) this.getSamplings(); })
        });
    },

    async getTypes(){
      await axios.get(this.db + 'types',
        {
          headers: this.headers_db
        }).then(response => {
          this.types = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.validateSession(error).then((resp) => { if(resp) this.getTypes(); })
        });
    },

    async getPlaces(){
      await axios.get(this.db + 'places',
        {
          headers: this.headers_db
        }).then(response => {
          this.places = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.validateSession(error).then((resp) => { if(resp) this.getPlaces(); })
        });
    },

    getSettings() {
        // this.loader = 'loading3'
        this.getTypes();
        this.dialogFactor = true;
      },

      saveFactor(payload) {
        console.log(" save factor",payload);
        // return;
        if (!parseFloat(payload.movement_price) > 0) {
          return;
        }
        console.log(" save factor",payload.movement_price);
        axios.post(this.db + 'movement_price/update', payload,
        {
          headers: this.headers_db
        })
        .then((response) => {
          console.log(response.data.message);
          this.$store.dispatch("setSnackbar", {
            text: response.data.message,
          });
          //this.getSamplings();
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("setSnackbar", {
            text: error,
          });
        });

      },
    // FIN Metodos base de datos

    // Metodos Generales
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    title() {
      return "Selecciona las fechas a filtrar";
    },
    updateDateFilter() {
      if (this.dates.length > 1) {
        if (moment(this.dates[0], "YYYY-MM-DD") > new Date(this.dates[1])) {
          this.dates = [this.dates[1], this.dates[0]];
        }
      } else {
        this.dates = [this.dates[0], this.dates[0]];
      }
    },

    close() {
      this.dialogDelete = false;
    },
    sumField(key) {
      return this.currentItems.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
    },

    getByCustomer() {
      console.log('dates', this.dates, this.id_coffee);

      // PLACE
      if (this.id_place && this.dates[0] && this.dates[1] && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.id_tipo_producto == this.id_coffee && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.id_place && this.dates[0] && this.dates[1] && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.id_tipo_producto == this.id_coffee && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.id_coffee && this.dates[0] && this.dates[1]) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return doc.id_tipo_producto == this.id_coffee && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.id_place && this.dates[0] && this.dates[1]) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return parseInt(doc.id_place) == parseInt(this.id_place) && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.id_place && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.id_tipo_producto == this.id_coffee;
        });
      }
      
      else if (this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          return doc.id_tipo_producto == this.id_coffee;
        });
      }

      else if (this.id_place) {
        this.currentItems = this.samplings.filter(doc => {
          console.log(doc.id_place, this.id_place);
          
          return parseInt(doc.id_place) == parseInt(this.id_place);
        });
      }

      else if (this.dates[0] && this.dates[1]) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }
      else {
        this.currentItems = this.samplings;
      }
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getAll() {
      this.loader = 'loading3'
      this.loading = true;
      this.getSamplings();
      this.getPlaces();
    },
  },
  async mounted() {
    this.loading = true;
    this.getSamplings();
    this.getPlaces();
    this.getTypes();
  },
};
</script>